<ngx-spinner bdColor="rgb(0,0,0, 0.3)" size="medium" color="#0af0d5" type="ball-scale-pulse" [fullScreen]="true">
  <p style="color: white"> </p>
</ngx-spinner>
